<template lang="pug">
    #bank-card-conciliation-list

        // table
        r-table(
            no-data-text='Sin conciliaciones bancarias.'
            no-remove
            no-search
            ref='table'
            remind-key='bank-card-conciliation-list'
            v-bind='tableProps' 
        )
            template( slot='items' )
                v-btn( color='success' @click='submitUpload' ) subir cartola &nbsp;
                    v-icon backup
                v-btn( color='info' @click='submitReviewSuggest' ) revisar sugerencias &nbsp;
                    v-icon done_all

        // dialog
        bank-card-conciliatio-upload( ref='upload' )
</template>

<script>
    //
    import { RTable } from '@/components/reusable_components/next'
    import BankCardConciliatioUpload from '@/components/upload/uploadBankCardFile'
    //
    import BankCardConciliationModel from '@/models/Accounting/AccBankCardConciliation'
    import BankCardConciliationFilters from '@/views/Accounting/AccBankCardConciliation/AccBankCardConciliationFilters'
    import BankCardConciliationHeaders from '@/views/Accounting/AccBankCardConciliation/AccBankCardConciliationHeaders'
    //
    export default {
        name: 'bank-card-conciliation-list',
        components: {
            BankCardConciliatioUpload,
            RTable,
        },
        computed: {

            /**
             * @description
             * { function_description }
             *
             * @return     {Object}  { description_of_the_return_value }
             */
            tableProps() {
                return {
                    filters: BankCardConciliationFilters,
                    headers: BankCardConciliationHeaders,
                    service: BankCardConciliationModel,
                }
            }
        },
        methods: {

            /**
             * @description
             * { function_description }
             */
            submitReviewSuggest() {
                this.$router.push({ name: 'bank-card-conciliations-suggest' })
            },

            /**
             * @description
             * { function_description }
             */
            submitUpload() {
                this.$refs.upload.dialog ^= 1
            },
        },
        mounted() {
            this.setTitle('Conciliaciones bancarias')
        },
        beforeRouteEnter(to, from, next) {
            next(ctx => {
                if (!ctx.$can('VIEW_ALL_ACCOUNT_BANK_CONCILIATION'))
                    ctx.$router.push('/')
            })
        },
    }
</script>